module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo-1.1db3fff5.jpg";